<script>
    import Panzoom from '@panzoom/panzoom';
    
    export default {
        name: 'canvas-area-zoom',
        mounted() {
            const vm = this;
            
            vm.panzoom = this.setupPanzoom(vm.$el);
            
            vm.defaultPan = vm.panzoom.getPan();
            
            //Event listeners have to be added 'manually'
            vm.$el.addEventListener('panzoomzoom', vm.handleZoom);
            vm.$el.addEventListener('wheel', vm.zoomWithWheel);
            vm.$el.addEventListener('panzoompan', vm.handlePan);

            //Enable scrolling our element via the parent element without actually moving the parent element
            if(vm.useParentElementAsProxy){
                vm.withProxiedPan(vm.$el.parentElement);   
            }
        },
        render(createElement, context) {
            return this.$slots.default;
        },
        methods: {
            setupPanzoom(element){
                return Panzoom(element, {
                    excludeClass: this.composerComponentClass
                });
            },
            withProxiedPan(proxyElement) {
                const proxiedPanzoom = this.setupPanzoom(proxyElement);
                const defaultPan = proxiedPanzoom.getPan();
                const {x: defaultX, y: defaultY} = defaultPan;
                let sessionPreviousPan = defaultPan;

                //Pan parameters are always relative to current 'pan' session
                //thus we need to reset our 'previousPan' upon session 'end'
                proxyElement.addEventListener('panzoomend', () => sessionPreviousPan = defaultPan);
                
                proxyElement.addEventListener('wheel', this.zoomWithWheel);
                proxyElement.addEventListener('panzoompan', () => {
                    const sessionCurrentPan = proxiedPanzoom.getPan();
                    const { x: currentX, y: currentY } = sessionCurrentPan;
                    const { x: previousX, y: previousY } = sessionPreviousPan;
                    
                    //Prevent an infinite loop due to our reset after every actual pan event
                    if(currentX === defaultX && currentY === defaultY) {
                        return;
                    }

                    //Save our previous pan/reset our actual pan as to not reflect our pan in the proxied element
                    proxiedPanzoom.pan(defaultX, defaultY);
                    sessionPreviousPan = sessionCurrentPan;

                    const actualPan = this.panzoom.getPan();
                    const scale = this.panzoom.getScale();
                    
                    //Scaler should be applied to ensure scrolling via our proxy happens at the same speed as our actual zoom
                    const sessionChangeX = (currentX - previousX) / scale;
                    const sessionChangeY = (currentY - previousY) / scale;
                    
                    this.panzoom.pan(
                        actualPan.x + sessionChangeX,
                        actualPan.y + sessionChangeY
                    );
                });
            },
            setScale(scale) {
                this.panzoom.zoom(scale);
            },
            zoomIn(){
                this.panzoom.zoomIn();
            },
            zoomOut(){
                this.panzoom.zoomOut();
            },
            zoomWithWheel(){
                if(this.panzoom){
                    this.panzoom.zoomWithWheel(...arguments);
                }
            },
            panToX(newX) {
                const {y} = this.panzoom.getPan();
                this.panzoom.pan(newX, y);
            },
            panToY(newY) {
                const {x} = this.panzoom.getPan();
                this.panzoom.pan(x, newY);
            },
            handlePan(){
                const pan = this.panzoom.getPan();
                const scale = this.panzoom.getScale();
                
                this.$emit('pan-changed', {
                    scale: scale,
                    x: pan.x,
                    y: pan.y
                });
            },
            handleZoom({detail}){
                this.$emit('scale-changed', detail);
            }
        },
        props: {
            useParentElementAsProxy: {
                type: Boolean,
                default: false,
                required: false
            },
            composerComponentClass: {
                type: String,
                required: false
            }
        },
        data: () => ({
            panzoom: null,
            defaultPan: { x: 0, y: 0 },
            previousPan: { x: 0, y: 0 }
        })
    }
</script>
